function menuToggle() {
  const toggleBtn = document.getElementById('oxg-main-menu-toggle');
  if(!toggleBtn) return;
  if (toggleBtn.dataset.menuToggleBound === 'true') return; // avoid double-binding on re-init (e.g. after Swup content:replace)
  toggleBtn.dataset.menuToggleBound = 'true';
  const headerOverlayBg = document.querySelector('.oxg-header-overlay-bg');
  const menu = document.getElementById('oxg-main-menu');
  const header = document.querySelector('.oxg-header');
  const mq = window.matchMedia('(max-width: 1279px)');

  // --- Scroll lock helpers ---
  const extraScrollEls = [
    // document.querySelector('.scroll-container-1'),
    // document.querySelector('.scroll-container-2')
  ];
  let savedScrollY = 0;
  let savedPositions = new Map();

  function disableBodyScroll() {
    console.log('disabling body scroll');
    // Save body scroll
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';

    // Save and lock other containers
    if(extraScrollEls) {
      extraScrollEls.forEach(el => {
        if (!el) return;
        savedPositions.set(el, { top: el.scrollTop, left: el.scrollLeft });
        el.style.overflow = 'hidden';
      });
    }
  }

  function enableBodyScroll() {
    console.log('re-enabling body scroll');
    // Restore body scroll
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);

    // Restore containers
    if(extraScrollEls) {
      extraScrollEls.forEach(el => {
        if (!el) return;
        el.style.overflow = '';
        const pos = savedPositions.get(el);
        if (pos) {
          el.scrollTop = pos.top;
          el.scrollLeft = pos.left;
        }
      });
      savedPositions.clear();
    }
  }

  function setInitialState() {
    if (mq.matches) {
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.setAttribute('aria-label', toggleBtn.dataset.ariaLabelOpen);
      header.setAttribute('aria-hidden', 'true');
      disableTabbing(header); // disable all focus inside header on mobile initially
    } else {
      toggleBtn.setAttribute('aria-expanded', 'true');
      toggleBtn.setAttribute('aria-label', toggleBtn.dataset.ariaLabelOpen); 
      header.removeAttribute('aria-hidden');
      enableTabbing(header); // ensure all elements are tabbable on desktop
    }
  }

  function cleanupIsOpen() {
    if (window.innerWidth > 1279 && header.classList.contains('is-open')) {
      header.classList.remove('is-open');
      headerOverlayBg.classList.remove('is-visible');
    }
  }

  // --- Tabbing helpers ---
  function disableTabbing(container) {
    const focusable = container.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    focusable.forEach(el => {
      if (el.getAttribute('tabindex') !== '-1') {
        el.dataset.tabindex = el.getAttribute('tabindex') || '';
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function enableTabbing(container) {
    const focusable = container.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    focusable.forEach(el => {
      if ('tabindex' in el.dataset) {
        const saved = el.dataset.tabindex;
        if (saved === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', saved);
        delete el.dataset.tabindex;
      }
    });
  }

  // --- Focus trap ---
  function trapFocus() {
    if (!mq.matches || !header.classList.contains('is-open')) return;

    const closeBtn = toggleBtn;
    const menuLinks = menu.querySelectorAll('a');
    const langLinks = header.querySelectorAll('.language-menu a'); // adjust selector
    const focusableElements = [closeBtn, ...menuLinks, ...langLinks];

    if (!focusableElements.length) return;

    let firstEl = focusableElements[0];
    let lastEl = focusableElements[focusableElements.length - 1];

    firstEl.focus();

    function handleKeydown(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    header.addEventListener('keydown', handleKeydown);

    const observer = new MutationObserver(() => {
      if (!header.classList.contains('is-open')) {
        header.removeEventListener('keydown', handleKeydown);
        observer.disconnect();
      }
    });
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  // --- Open/close toggle ---
  function openClose() {
    if (!mq.matches) return;

    const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', String(!expanded));
    toggleBtn.setAttribute('aria-label', expanded ? toggleBtn.dataset.ariaLabelOpen : toggleBtn.dataset.ariaLabelClose);

    if (expanded) {
      headerOverlayBg.classList.remove('is-visible');
      header.setAttribute('aria-hidden', 'true');
      header.classList.remove('is-open');
      disableTabbing(header); // prevent focus when closed
      enableBodyScroll();
    } else {
      header.removeAttribute('aria-hidden');
      header.classList.add('is-open');
      headerOverlayBg.classList.add('is-visible');
      enableTabbing(header); // allow focus when open
      trapFocus();
      disableBodyScroll();
    }

    toggleBtn.querySelector('.menu-icon').classList.toggle('is-hidden', !expanded);
    toggleBtn.querySelector('.close-icon').classList.toggle('is-hidden', expanded);
  }

  toggleBtn.addEventListener('click', () => {
    openClose();
  });

  headerOverlayBg.addEventListener('click', () => {
    if (headerOverlayBg.classList.contains('is-visible')) { 
      openClose();
    }
  });

  // --- Close on Escape ---
  function handleEscape(e) {
    if (!mq.matches) return; // only on mobile
    if (e.key === 'Escape' && header.classList.contains('is-open')) {
      openClose();
    }
  }

  document.addEventListener('keydown', handleEscape);

  setInitialState();
  mq.addEventListener('change', setInitialState);
  window.addEventListener('resize', cleanupIsOpen);
  cleanupIsOpen();
}

document.addEventListener('DOMContentLoaded', () => {
  menuToggle();
});

// Swup swaps #brx-header (which contains the mobile menu markup) on every
// page transition, so the toggle button/overlay are fresh DOM nodes with no
// listeners after each navigation — re-bind them.
document.addEventListener('oxg:contentReplaced', () => {
  menuToggle();
});
